import { gql } from "@/__generated__/gql";

export const DESTROY_FEED_POST_MUTATION = gql(`
  mutation DestroyFeedPost($input: DestroyFeedPostMutationInput!) {
    destroyFeedPostMutation(input: $input) {
      clientMutationId
      errors {
        message
        title
      }
      success
    }
  }
`);
